/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/304-infinite': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M12.25 11.75a3.728 3.728 0 01-2.652-1.098L8 9.054l-1.598 1.598c-.708.708-1.65 1.098-2.652 1.098s-1.944-.39-2.652-1.098C.39 9.944 0 9.002 0 8s.39-1.943 1.098-2.652C1.806 4.64 2.748 4.25 3.75 4.25s1.943.39 2.652 1.098L8 6.946l1.598-1.598c.708-.708 1.65-1.098 2.652-1.098s1.944.39 2.652 1.098C15.61 6.056 16 6.998 16 8s-.39 1.943-1.098 2.652a3.726 3.726 0 01-2.652 1.098zm-1.598-2.152c.427.427.994.662 1.598.662s1.171-.235 1.598-.662c.427-.427.662-.994.662-1.598s-.235-1.171-.662-1.598c-.427-.427-.994-.662-1.598-.662s-1.171.235-1.598.662L9.054 8l1.598 1.598zM3.75 5.74c-.604 0-1.171.235-1.598.662S1.49 7.396 1.49 8c0 .604.235 1.171.662 1.598s.994.662 1.598.662c.604 0 1.171-.235 1.598-.662L6.946 8 5.348 6.402A2.244 2.244 0 003.75 5.74z"/>'
  }
})
